import axios from 'axios'
import { Toast } from 'vant'; // 导入轻提示
import Cookies from "js-cookie";
import router from '@/router'
// import NProgress from 'nprogress';
// import 'nprogress/nprogress.css';
 // NProgress 配置
//  NProgress.configure({
//     showSpinner: false
//   });
let _axios
if (window.location.href.includes("192.168")){
   _axios = axios.create()
}else{
   _axios = axios.create({
    // baseURL: 'http://192.168.10.235:888',
   //   baseURL: 'http://zhongzw1024.vicp.cc/',
    //  正式环境 
    
    // baseURL: `${window.location.origin}`                     
  // baseURL: 'http://localhost:888'
  baseURL: `${window.location.origin}`      
    })
}

 //跨域请求，允许保存cookie
 Toast.setDefaultOptions({ duration: 4000,closeOnClick:true,});

 _axios.defaults.withCredentials = true;
// 请求拦截器
let url = ''
let toastLoading = ''
//let toast = ''
_axios.interceptors.request.use(

  (config) => {
    url = config.url
    toastLoading =  Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration:0,
    });
    // config.headers['x_token']=localStorage.getItem("token")
    config.headers['x_token']= Cookies.get(localStorage.getItem("t") + "token")

    if (config.data) {
      config.data.movieChannel =  JSON.parse(localStorage.getItem('mallInfo')).movieChannel || ''
    }else{
      config.data ={}
      config.data.movieChannel = JSON.parse(localStorage.getItem('mallInfo')).movieChannel || ''
    }

    if(url.includes('card/check/ntoken') || url.includes('member/pay')    || url.includes('mall/widget') 
      || url.includes('mobile/code/ntoken')
    || url.includes('login/mobile/check')
    || url.includes('card/bind') ){
      config.headers['Content-Type']= `application/x-www-form-urlencoded`
    }
    return config
  },
  (error) => {
    toastLoading.clear()
    return Promise.reject(error)
  }
)

// 响应拦截器
_axios.interceptors.response.use(
  (res) => {
    toastLoading.clear()

    const status = res.data.returnStatus ;
    const message = res.data.message  || '影院数据异常,请联系客服!';
    if (status !== 'SUCCESS') {
       if (status === 'LOGOUT') {
        Toast.fail('登录超时,请重新登录');
    setTimeout(() => {
      if(localStorage.getItem("t")){
        window.location = `${
          window.location.origin + "/shop"
        }/?t=${localStorage.getItem("t")}#/login`;
      }
    }, 2000);
        }else{
          if(status ===  'DONT'){

            return res.data
          }else{
          
            Toast(message);
            return Promise.reject(new Error(message))
          }
        }
      }

      return res.data.data;
  },
  /**/
  (error) => {
  //  toast.clear()
 //   NProgress.done();
    console.log(error);
    toastLoading.clear()


      Toast.fail(error);
    

    return Promise.reject(new Error(error));
  }
)

export default _axios
